import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { LoadingState } from './core/loading.state';
// import { register } from 'swiper/element/bundle';
import { BehaviorSubject, switchMap } from 'rxjs';
import { AppFeaturesService } from './portal/app-features.service';
import { AppFeaturesLang, AppFeaturesState } from './portal/app-feature.state';
import { NavController } from '@ionic/angular';
import { StatusBar, Style } from '@capacitor/status-bar';
import { App } from '@capacitor/app';
import { AuthService } from './portal/auth.service';
import { RouteToInsideHome } from './portal/routing.state';

// register();

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
	title = 'DanceBug';
	currentIndex = 1;
	splashLoading = true;
	splashImage: BehaviorSubject<string> = new BehaviorSubject(`../assets/splash/splash-01.png`);
	loadingWithSpinner$ = this.store.select(LoadingState.loadingWithSpinner);

	constructor(
		private store: Store,
		private appFeaturesService: AppFeaturesService,
		private appFeaturesState: AppFeaturesState,
		private navController: NavController,
		private authService: AuthService
	) {
		App.addListener('appUrlOpen', (event) => {
			const url = event.url;

			if (url?.startsWith('dancebug://')) {
				const parsed = new URL(url);
				const path = parsed.hostname; // e.g., "login"
				const token = parsed.searchParams.get('token');

				console.log('DEEP LINK OPENED WITH TOKEN', token);

				if (path === 'login' && token) {
					this.authService
						.exchangeToken(token)
						.pipe(switchMap(() => this.store.dispatch(new RouteToInsideHome())))
						.subscribe();
				}
			}
		});
	}

	ngOnInit() {
		// Set global orientation support
		this.appFeaturesService.screenLock();

		StatusBar.setStyle({ style: Style.Dark }).catch((err) => {
			console.error('Failed to change status bar style', err);
		});

		const id = setInterval(() => {
			this.currentIndex++;
			const index = this.currentIndex.toString().padStart(2, '0');
			this.splashImage.next(`../assets/splash/splash-${index}.png`);

			if (this.currentIndex == 60) {
				clearInterval(id);
				this.splashLoading = false;
			}
		}, 50);

		const checkVersion = setInterval(() => {
			this.checkVersion(checkVersion);
		}, 30 * 60 * 1000);

		setTimeout(async () => {
			let requestLang = await this.appFeaturesService.getCurrentLang();
			const { lang, langData } = this.appFeaturesState;

			if (Object.keys(langData).length > 0 && requestLang === lang) {
				return;
			}

			if (requestLang === null) requestLang = 'en';

			this.store.dispatch(new AppFeaturesLang(requestLang));
		}, 1500);
	}

	checkVersion(id?: NodeJS.Timeout) {
		this.appFeaturesService.getInfo('app_info').subscribe((appInfo) => {
			const serverInfo = appInfo.data.appInfo;
			const currentInfo = this.appFeaturesState.appInfo;

			const currentVersion = (currentInfo && `${currentInfo.version}(${currentInfo.build})`) || this.appFeaturesState.appVersion;

			let requiredVersion = '0.0.1';

			if (this.appFeaturesState.isNativeIos) {
				requiredVersion = `${serverInfo.ios.requireVersion}(${serverInfo.ios.requireBuild})`;
			} else if (this.appFeaturesState.isNativeAndroid) {
				requiredVersion = `${serverInfo.android.requireVersion}(${serverInfo.android.requireBuild})`;
			}

			if (requiredVersion.localeCompare(currentVersion, undefined, { numeric: true }) > 0) {
				this.navController.navigateRoot('/update-required');
				if (id) {
					clearInterval(id);
				}
			}
		});
	}
}
